export default "__VITE_ASSET__Dr7Q3vY2__"